import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error ui-addon-i18n isn't typed
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import usePaymentsAccountUnderwritingData from '../../../../common/hooks/usePaymentsAccountUnderwritingData';
import { jsx as _jsx } from "react/jsx-runtime";
const getAccountAndBillingPageURL = () => `/account-and-billing/${PortalIdParser.get()}/overview`;
const PortalDowngradeCanceledSubscriptionsAlert = () => {
  var _data$paymentsAccount;
  const {
    data
  } = usePaymentsAccountUnderwritingData();
  const underwritingRevokedDate = data === null || data === void 0 || (_data$paymentsAccount = data.paymentsAccountUnderwriting) === null || _data$paymentsAccount === void 0 || (_data$paymentsAccount = _data$paymentsAccount.underwritingProperties) === null || _data$paymentsAccount === void 0 ? void 0 : _data$paymentsAccount.underwritingStatusRevokeDate;
  if (!underwritingRevokedDate || underwritingRevokedDate < new Date().valueOf()) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "commerceSharedComponents.alerts.integrator.PortalDowngradeCanceledSubscriptionsAlert.title_jsx",
      options: {
        revokeDate: {
          value: underwritingRevokedDate,
          format: 'l'
        }
      },
      elements: {
        FormattedDateTime
      }
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "commerceSharedComponents.alerts.integrator.PortalDowngradeCanceledSubscriptionsAlert.description_jsx",
      options: {
        learnMore: {
          url: 'https://knowledge.hubspot.com/account/how-do-i-cancel-my-hubspot-account',
          external: true
        },
        upgradeNow: {
          href: getAccountAndBillingPageURL(),
          external: true
        }
      },
      elements: {
        Link,
        KnowledgeBaseButton
      }
    })
  });
};
export default PortalDowngradeCanceledSubscriptionsAlert;